import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {Field, reduxForm} from 'redux-form';
import {SelectInput} from 'admin-on-rest';
import FormattedDateTextInput from './FormattedDateTextInput';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import {filterStyles} from '../shared/styles-filter';
import {viewStyles} from '../shared/styles-view';

/**
 * Set a field for filter entry
 *
 * @param touched
 * @param error
 * @param inputProps
 * @param props
 * @return {*}
 */
const renderInput = ({meta: {touched, error} = {}, input: {...inputProps}, ...props}) => {
    return (
        <TextField
            errorText={touched && error}
            {...inputProps}
            {...props}
        />
    )
};

class RepacksRetailBoxesSearchFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allowSearch: false,
            searchType: null
        };
    }

    handleTypeFilterSelect = (e, index, value) => {
        let allowSearch = (index && index === 'any');
        let searchType = (index === 'any') ? this.state.searchType : null;
        this.setState({
            allowSearch: allowSearch,
            searchType: searchType
        });
    };

    handleSearchFilterSelect = (e, index, value) => {
        let searchType = (index) ? index : null;
        this.setState({
            searchType: searchType
        });
    };

    handleFilterSubmit = () => {
        if (typeof this.props.onSubmitFilter === 'function') {
            const {allowSearch, searchType} = this.state;
            this.props.onSubmitFilter({
                allowSearch: allowSearch,
                collectionType: (this.props.filterType) ? this.props.filterType : '',
                dateFrom: (this.props.filterDateFrom) ? this.props.filterDateFrom : '',
                dateTo: (this.props.filterDateTo) ? this.props.filterDateTo : '',
                searchId: (allowSearch && searchType === 'id') ? this.props.filterId : '',
                searchName: (allowSearch && searchType === 'product') ? this.props.filterProduct : '',
                type: (this.props.filterType) ? this.props.filterType : '',
            });
        }
    };

    isDisabled = (props) => {
        const {
            filterDateFrom,
            filterDateTo,
            filterId,
            filterProduct,
            filterType,
            loading
        } = props;

        const {
            allowSearch,
            searchType
        } = this.state;

        return (
            loading ||
            !filterDateFrom || filterDateFrom === '' ||
            !filterDateTo || filterDateTo === '' ||
            !filterType || filterType === '' ||
            (allowSearch && !searchType) ||
            (allowSearch && searchType === 'id' &&
                (
                    !filterId ||
                    filterId === '' ||
                    filterId.length < 3
                )
            ) ||
            (allowSearch && searchType === 'product' &&
                (
                    !filterProduct ||
                    filterProduct === '' ||
                    filterProduct.length < 3
                )
            )
        );
    };

    render() {
        const {
            filterDateFrom
        } = this.props;

        const {
            allowSearch,
            searchType
        } = this.state;

        const styles = {
            selectContainer: {display: 'inline-block', marginRight: 10, marginBottom: '-1px', verticalAlign: 'bottom'}
        };

        const minToDate = new Date(filterDateFrom);
        const disabled = this.isDisabled(this.props);

        return (
            <form>
                <div className="list-filter">
                    <span style={styles.selectContainer}>
                        <Field
                            name="filter_type"
                            component={SelectInput}
                            choices={[
                                {id: 'any', name: 'Repacks and Retail Boxes'},
                                {id: 'repack', name: 'Repacks'},
                                {id: 'retail_box', name: 'Retail Boxes'}
                            ]}
                            defaultValue="any"
                            label="Collection Type"
                            onChange={this.handleTypeFilterSelect}
                            elStyle={viewStyles.rowShowFieldWide}
                        />
                    </span>
                    <span style={viewStyles.filterInline}>
                        <FormattedDateTextInput
                            formName="filterForm"
                            source="filter_date_from"
                            label="Select Date From"
                            placeholder="MM/DD/YYYY"
                            allowInputValue={false}
                            style={{...viewStyles.filterDateSelect, ...viewStyles.filterHalf}}
                        />
                    </span>
                    <span style={viewStyles.filterInline}>
                        <FormattedDateTextInput
                            formName="filterForm"
                            source="filter_date_to"
                            label="Select Date To"
                            placeholder="MM/DD/YYYY"
                            minDate={minToDate}
                            allowInputValue={false}
                            style={{...viewStyles.filterDateSelect, ...viewStyles.filterHalf}}
                        />
                    </span>
                    <hr style={filterStyles.break}/>
                    <span style={(allowSearch) ? styles.selectContainer : filterStyles.hidden}>
                        <Field
                            name="filter_search_select"
                            component={SelectInput}
                            choices={[
                                {id: 'id', name: 'Search by Collection ID'},
                                {id: 'product', name: 'Search by Product Name'}
                            ]}
                            label="Search ID or Product"
                            onChange={this.handleSearchFilterSelect}
                            elStyle={viewStyles.rowShowFieldWide}
                        />
                    </span>
                    <Field
                        id="filter_search_id"
                        name="filter_search_id"
                        type="text"
                        component={renderInput}
                        floatingLabelText="Enter a Collection ID"
                        style={(searchType === 'id') ? filterStyles.textInputWide : filterStyles.hidden}
                    />
                    <Field
                        id="filter_search_product"
                        name="filter_search_product"
                        type="text"
                        component={renderInput}
                        floatingLabelText="Enter a Product Name"
                        style={(searchType === 'product') ? filterStyles.textInputWide : filterStyles.hidden}
                    />
                    <RaisedButton
                        primary
                        type="button"
                        label="Search"
                        disabled={disabled}
                        onClick={this.handleFilterSubmit}
                        style={filterStyles.submitButton}
                    />
                    <hr style={filterStyles.break}/>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['filterForm'];
    if (form && form.values) {
        return {
            filterDateFrom: form.values.filter_date_from,
            filterDateTo: form.values.filter_date_to,
            filterId: form.values.filter_search_id,
            filterProduct: form.values.filter_search_product,
            filterType: form.values.filter_type
        }
    }
    return {
        filterDateFrom: '',
        filterDateTo: '',
        filterId: '',
        filterProduct: '',
        filterType: ''
    }
};

RepacksRetailBoxesSearchFilter.propTypes = {
    loading: PropTypes.bool,
    onSubmitFilter: PropTypes.func
};

const enhance = compose(
    connect(
        mapStateToProps
    ),
    reduxForm({
        form: 'filterForm'
    })
);

export default enhance(RepacksRetailBoxesSearchFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/RepacksRetailBoxesSearchFilter.js